import { Suspense } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import RootUserLayout from "../layout";
import { useDashboardData } from "../service/dashboard";
import { OrganizationTable } from "./components/organization-table";
import { StatCards } from "./components/stat-cards";
import { GrowthChart } from "./components/charts/growth-chart";
import { StatusDistributionChart } from "./components/charts/status-distribution-chart";
import { TOP_NAV } from "./constants";

export default function DashboardRootUser() {
  return (
    <RootUserLayout pageTitle="Overview" topNav={TOP_NAV}>
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Dashboard..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <DashboardContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}

function DashboardContent() {
  const {
    totalOrgs,
    activeOrgs,
    growthRate,
    activeToday,
    activeThisWeek,
    responsiblePersonCount,
    recentOrgs,
    monthlyTrendData,
    statusDistribution,
  } = useDashboardData();

  return (
    <div className="space-y-4">
      <StatCards
        totalOrgs={totalOrgs}
        activeOrgs={activeOrgs}
        growthRate={growthRate}
        activeToday={activeToday}
        activeThisWeek={activeThisWeek}
        responsiblePersonCount={responsiblePersonCount}
      />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-7">
        <Card className="col-span-1 lg:col-span-4">
          <CardHeader>
            <CardTitle>Growth Overview</CardTitle>
            <CardDescription>
              Monthly organization registrations
            </CardDescription>
          </CardHeader>
          <CardContent>
            <GrowthChart data={monthlyTrendData} />
          </CardContent>
        </Card>

        <Card className="col-span-1 lg:col-span-3">
          <CardHeader>
            <CardTitle>Organization Status</CardTitle>
            <CardDescription>Active vs Inactive distribution</CardDescription>
          </CardHeader>
          <CardContent>
            <StatusDistributionChart data={statusDistribution} />
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Recent Organizations</CardTitle>
          <CardDescription>
            Latest 5 organizations added to the platform
          </CardDescription>
        </CardHeader>
        <CardContent>
          <OrganizationTable data={recentOrgs} />
        </CardContent>
      </Card>
    </div>
  );
}
